"use strict";

angular.module("customer")
.controller("PaymentListController", function(
    $scope, $resource, $state, $stateParams, StateExtensionService, PaymentService, UserService,
    PaymentStatusFilterService, PaymentMethodsService
) {
    var _this = this;
    $scope.pagination = {};
    $scope.params = angular.extend({}, $stateParams);
    $scope.statusNamesLocalized = PaymentService.getStatusNamesLocalized();
    $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();
    $scope.statusFilterService = PaymentStatusFilterService;

    UserService.isUserFetched().then(function onSuccess(user) {
        if (user) {
            $scope.dedicatedVendorId = user.dedicated_vendor_id;
            $scope.isUserCanPay = user.is_user_can_pay;
        }
    });

    $scope.$on("listingFilterUpdated", function(event, filters) {
        $scope.pagination.current_page = 1;
        StateExtensionService.updateUrlParams(filters);
        angular.extend($scope.params, filters);
        _this.fetch();
    });

    this.getDisabledButtonPayHelpTipHtmlContent = function() {
        return gettextCatalog.getString("Your owner didn't grants you access to the payment feature.");
    };

    this.onPageChanged = function() {
        $scope.params = angular.extend($scope.params, {
            page: $scope.pagination.current_page
        });
        this.fetch();
    };

    this.fetch = function() {
        PaymentService.query($scope.params).$promise
        .then(function onSuccess(data) {
            $scope.pagination = data.pagination;
            $scope.payments = data.results;
            StateExtensionService.updateUrlParams({page: $scope.pagination.current_page});
        });
    };

    this.seeDetails = function(id) {
        $state.go("paymentDetails", {id: id});
    };

    this.seeUnpaidInvoices = function() {
        if (!$scope.isUserCanPay) {
            return;
        }

        $state.go('payment', {selectAll: true});
    };

    this.fetch();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/payment/payment-list.controller.js
// module id = 916
// module chunks = 0